import React from 'react';
import { SearchBar } from './search-bar';
import { SearchResult } from './result-list';
import { CepStore } from './cep-context';

export function CepPage({back}:{back:()=>void}){
    return <CepStore><div className=''>
        <div className='d-flex align-items-center mb-4'><i className='fa fa-arrow-left me-3' style={{position:"relative", top:"-2px"}} onClick={back}></i> <h3 className='flex-grow'>Buscar CEPs de cidades</h3></div>
        <SearchBar />
        <SearchResult />
    </div></CepStore>
}